<template>
    <div class="editabel-area mb-2">
        <div class="d-flex justify-content-between align-items-start" v-click-outside="toggleEditable">
            <!-- <textarea
                class="w-100 p-1 mr-3"
                :class="{editable, isTitle: type === 'title'}"
                :readonly='!editable'
                :name="`${type}`"
                :id="`edit-${type}`"
                v-model="inputVal"/> -->
            <md-field  class="w-100 p-1 mr-3" :id="`edit-${type}`" :class="{editable}">
                <md-textarea
                    class="w-100 p-1 mr-3"
                    :class="{editable, 'is-title': type === 'title'}"
                    :readonly='!editable'
                    :name="`${type}`"
                    v-model.trim="inputVal"
                    :maxlength="maxLength"
                    :placeholder="`Project ${type}*`"/>
            </md-field>
            <Icon 
                v-b-tooltip.hover.top
                :title="`Edit ${type}`"
                @click.native ="toggleEditable(true)"
                :id="`edit-${type}-button`"
                class="cursor-pointer mt-2"
                icon = 'edit-icon' />
        </div>
        <slot></slot>
    </div>
</template>

<script>
import {clickOutside} from "@/directives/clickOutside";
import Icon from './Icon'
import {ref, watch} from '@vue/composition-api'

export default {
    props: {
        initialValue: String,
        type: String,
        height: String,
        maxLength: {
            default: 500,
            type: Number
        }
    },
    directives: {
        clickOutside
    },
    components: {
        Icon
    },
    setup(props, {emit}){
        const editable = ref(false) 
        const inputVal = ref(props.initialValue || '')
        
        const toggleEditable = val => {
            editable.value = val === true
        }

        watch(inputVal, inputVal => {
            emit('setInfo', inputVal)
        })

        return {
            editable,
            toggleEditable,
            inputVal
        }
    }
}
</script>

<style lang="scss">
    [id^="edit-"] {
        .md-count {
            // right: 30px;
            // bottom: 5px;
            display: none;
        }

        &.editable .md-count {
            display: block
        }

        .md-field {
            margin: 0 10px 0 0!important
        }
    }

    
</style>

<style lang="scss" scoped>
    .editabel-area {
        textarea {
            // height: 100px;
            // border: 0;
            color: #333333;
            resize: none;
            font-size: 16px;
            line-height: 24px;
            height: 120px;

            &.is-title {
                font-size: 20px;
                line-height: 32px;
                font-weight: bold;
            }
           
        }

        [id^="edit-"] {
            border: none;
            &.editable {
                border: 1px solid #00000026;
                border-radius: 4px;
            }
            textarea {
                padding: 12px 16px;
                resize: none;
                min-height: 164px;
                color: #718096!important;
                -webkit-text-fill-color: #718096;
            }

            &:before, &:after {
                content: none!important;
            }
        }

    }
</style>